/**
 * OpenApp: merchantPanel
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface MerchantLoginResultAnyOf { 
    setupToken: string;
    nextStep: MerchantLoginResultAnyOf.NextStepEnum;
}
export namespace MerchantLoginResultAnyOf {
    export const NextStepEnum = {
        PasskeySetupRequired: 'PASSKEY_SETUP_REQUIRED'
    } as const;
    export type NextStepEnum = typeof NextStepEnum[keyof typeof NextStepEnum];
}


